import type { AutoFormInputComponentProps } from "../types"
import { FormControl, FormItem, FormMessage } from "@/components/ui/form"
import { TimePicker } from "@/components/ui/time-picker"
import { cn } from "@/lib/utils"
import AutoFormLabel from "../common/label"
import AutoFormTooltip from "../common/tooltip"

function AutoFormTimePicker({
  label,
  isRequired,
  fieldConfigItem,
  fieldProps,
  field,
}: AutoFormInputComponentProps) {
  const { showLabel: _showLabel, ...fieldPropsWithoutShowLabel } = fieldProps
  const showLabel = _showLabel === undefined ? true : _showLabel

  return (
    <div className={cn("flex flex-row items-center space-x-2", fieldConfigItem?.containerClassName)}>
      <FormItem className="flex w-full flex-col justify-start">
        {showLabel && (
          <AutoFormLabel
            isRequired={isRequired}
            label={fieldConfigItem?.label || label}
          />
        )}
        <FormControl>
          <TimePicker
            onChange={field.onChange}
            value={field.value || ""}
            {...fieldPropsWithoutShowLabel}
          />
        </FormControl>
        <AutoFormTooltip fieldConfigItem={fieldConfigItem} />
        <FormMessage />
      </FormItem>
    </div>
  )
}

export default AutoFormTimePicker
